// Redesigned "v2" Track Record baseball-card component. NEW file — the original
// in @roc/ui's borrowerBaseballCard is untouched. Exported under a *V2 name and
// consumed by @roc/feature-track-record-v2 (new CRM / internal Track Record UI).

import { Box, Grid, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { CloudDownload } from '@material-ui/icons';
import { ReactNode } from 'react';

const useStyles = makeStyles(theme =>
  createStyles({
    header: {
      alignItems: 'center',
      display: 'flex',
      backgroundColor: '#f5f5f5',
      border: '1px solid #e0e0e0',
      borderRadius: 8,
      padding: '12px 20px',
      marginBottom: 0,
    },
    verificationStatusCell: {
      textAlign: 'right',
    },

    nonEditableInput: {
      padding: '2% 2% 0 2%',
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none',
    },
    editableInput: {
      padding: '2% 2% 0 2%',
      backgroundColor: 'transparent',
      border: '1px solid #ccc',
      borderRadius: '5px',
      outline: 'none',
    },
    gridItem: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    gridItem2: {
      display: 'flex',
      flexDirection: 'column',
    },
    gridLabel: {
      fontWeight: 'bold',
      fontSize: '14px',
    },
    gridCancelLabel: {
      fontWeight: 'bold',
      fontSize: '14px',
      color: 'red',
    },
    gridValue: {
      fontSize: '14px',
    },
    datePicker: {
      width: '95%',
    },
    expandMore: {},
    expanded: {
      maxHeight: 'unset',
    },
    notExpanded: {
      maxHeight: '400px',
      overflow: 'hidden',
    },
    expandBtn: {
      display: 'flex',
      justifyContent: 'center',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    },
    boldText: {
      fontWeight: 'bold',
    },
    infoIcon: {
      color: theme.palette.primary.main,
      fontSize: '1.3rem',
      marginLeft: '5px',
      position: 'relative',
      top: '5px',
    },
    radioGroup: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
    radio: {
      color: theme.palette.primary.main,
    },
    radioLabel: {
      fontSize: '14px',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      '& td': {
        padding: '3px 10px',
      },
    },
    divider: {
      margin: '10px 0',
    },
  })
);

interface TrackRecordStoreShape {
  document?: { borrowerName?: string; loanTaskId?: any };
  canDownloadFile: boolean;
  downloadDocument(): void;
}

interface TrackRecordLineItemProps {
  hideTitle?: boolean;
  store: TrackRecordStoreShape;
  borrowerId: number;
  onClose: () => void;
  children?: ReactNode;
}

export const TrackRecordLineItem = observer(({ hideTitle = false, store, borrowerId, onClose, children }: TrackRecordLineItemProps) => {

  const classes = useStyles();

  return (
    <Grid container style={{ width: '100%' }}>
      {!hideTitle && (
        <Grid item xs={12} className={classes.header}>
          <Typography variant='subtitle1' style={{ fontWeight: 700, fontSize: 15 }}>
            {store.document?.borrowerName || 'Unknown'}
            {' - '}
            <span style={{ color: '#888', fontWeight: 400 }}>Track Record</span>
          </Typography>
          {store.canDownloadFile && (
            <Box display="flex" justifyContent="flex-end">
              <IconButton
                color="primary"
                aria-label="download"
                onClick={() => store.downloadDocument()}
                size="small"
              >
                <CloudDownload />
              </IconButton>
            </Box>
          )}
        </Grid>
      )}
      <Grid item xs={12}>
        {children}
      </Grid>
    </Grid>
  );
});

export default TrackRecordLineItem;
